import { Component } from '@angular/core';
import { BaseServiceService } from '../../../services/base-service.service';
import { Utilities } from '../../../helpers/utilities';
import { HelperImages } from '../../../helpers/helper-images';
import { HelperRules } from '../../../helpers/helper-rules';
import { HelperActions } from '../../../helpers/helper-actions';
import { GeneralFormComponent } from '../../controls/general-form/general-form.component';

@Component({
  selector: 'app-tdescarga',
  templateUrl: '../../controls/general-form/general-form.component.html',
  styleUrls: ['../../controls/general-form/general-form.component.scss']
})
export class TdescargaComponent extends GeneralFormComponent {

  constructor(public baseService: BaseServiceService, public utility: Utilities,
    public helperImages: HelperImages, public helperRules: HelperRules,
    public helperActions: HelperActions) {
    super(baseService, utility, helperImages, helperRules, helperActions);
  }

  public OnActionEventHandler(event: any) {
    // Intercepta únicamente la descarga de archivos generados.
    // Las demás opciones mantienen el comportamiento de GeneralFormComponent.
    if (event.ControlType == 'CommandButton' && event.Option &&
      event.Option.Name == 'DescargarArchivoGenerado') {
      // debugger
      this.Pagina
      this.DescargarArchivoGenerado(event);
      return;
    }

    super.OnActionEventHandler(event);
  }

  private DescargarArchivoGenerado(event: any) {
    const action = event.Option.Actions[0];
    const obj = this.utility.GetApiModel('Descargar', 'Download');

    // Envía al backend el registro seleccionado en la grilla.
    // El modelo contiene la ubicación y configuración necesarias para recuperar el archivo.
    obj.Model = this.modelo.modelo;

    // Solicita el contenido en Base64 para mantener el mismo comportamiento
    // utilizado anteriormente por los procesos síncronos de Índice, Foliado y ZIP.
    obj.DataAdd = {
      DownloadFileRequest: JSON.stringify({
        FileModelType: 'Documents',
        ResultType: 'Base64',
        DownloadOption: 'SendToScreen',
        IsDownload: true
      })
    };

    const info = {
      componentName: 'TDescargaController',
      method: 'Download',
      processMessage: action.ProcessMessage || 'Descargando archivo generado...'
    };

    // El endpoint recupera el archivo desde el proveedor configurado,
    // inactiva el registro y retorna el FileResult al frontend.
    this.baseService.Download(obj, info, 'TDescarga', false, false)
      .then(data => this.ProcesarDescarga(data))
      .catch(error => {
        this.utility.logger.LogError(error, obj, {
          componentName: 'TDescarga',
          method: 'DescargarArchivoGenerado'
        });
      });
  }

  private ProcesarDescarga(data: any) {
    const result = data && data.Data ? data.Data : null;

    if (!result)
      return;

    // Descarga el archivo según el tipo de resultado retornado por el backend.
    if (result.ResultType == 'ByteArray')
      this.utility.DownloadByBytes(result);
    else if (result.ResultType == 'Base64')
      this.utility.DownloadByBase64(result);
    else if (result.ResultType == 'Url' || result.ResultType == 'None')
      this.utility.DownloadByUrl(result);

    // Actualiza la grilla para retirar el registro que fue inactivado en el backend.
    this.ReCargarGrilla();
  }
}